"use strict";
/**
 * TooltipComponent
 *
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var material_1 = require("@mui/material");
var react_redux_1 = require("react-redux");
var crude_selector_1 = require("../../../store/crude/crude.selector");
var TooltipComponent = function (props) {
    var crudeLicense = react_redux_1.useSelector(crude_selector_1.getCrudeLicense);
    // manage Licenses
    var tooltipLicense = crudeLicense.tooltips.available;
    return (react_1.default.createElement(react_1.default.Fragment, null, tooltipLicense ? (react_1.default.createElement(material_1.Tooltip, { title: props.title, placement: props.placement || 'right' }, props.element))
        : (react_1.default.createElement(react_1.default.Fragment, null, props.element))));
};
exports.default = TooltipComponent;
